/**
 * Middleware used to reset the redux form in some situations, ie return back to home page means the user
 * is starting the application new, so wipe it.
 */
import { UNREGISTER_FIELD } from 'redux-form/lib/actionTypes';
import { ConnectedRouter } from '@jauntin/react-ui';
import { reset, updateSyncErrors } from 'redux-form';
import RouteParser from '../Helpers/RouteParser';
import { getById } from '../Helpers/EventTypes';
import {
  formName,
  cancelFormName,
  samplePolicyFormName,
} from '../Constants/constants';
import Debounce from '../Helpers/Debounce';

const debounce = new Debounce({ period: 300 });

const ReduxFormMiddleware = (store) => (next) => (action) => {
  next(action);
  if (action.type === ConnectedRouter.LOCATION_CHANGE) {
    const routeParser = RouteParser.create(action.payload.location.pathname);
    const eventType =
      getById(
        routeParser.selectedEventType(),
        store.getState().formPage.eventTypes,
      ) || null;
    if (eventType === null) {
      store.dispatch(reset(formName));
    }
    store.dispatch(reset(cancelFormName));
    store.dispatch(reset(samplePolicyFormName));
  }
  if (action.type === UNREGISTER_FIELD) {
    // Sometimes syncErrors don't get updated when fields are unregistered.
    // But we rely on that
    debounce.do(() =>
      store.dispatch(
        updateSyncErrors(formName, store.getState().form[formName].syncErrors),
      ),
    );
  }
};

export default ReduxFormMiddleware;
